import AlertModal from 'src/components/ui-kit/AlertModal';
import styled from 'styled-components/macro';

const ModalWrapper = styled.div`
  text-align: left;
`;
const ModalMain = styled.div`
  font-family: NotoSansTC-Bold;
  font-size: 20px;
  font-weight: 700;
`;
const ModalAnnotation = styled.div`
  font-size: 16px;
  font-weight: 400;
`;

/**
 * UUID 檢核提醒視窗
 */
const UuidAlertModal: React.FC = () => {
  return (
    <AlertModal width={'22em'}>
      <ModalWrapper>
        <ModalMain>掃描之證書非有效，已另換發或補發</ModalMain>
        <ModalAnnotation>按下關閉以顯示最新權證資訊。</ModalAnnotation>
      </ModalWrapper>
    </AlertModal>
  );
};

export default UuidAlertModal;
